import React from "react";
import Tabs from "../../../components/common/Tabs";
import { OverviewTabsData } from "../../../config/tabsConfig";
import BreadCrumbs from "../../../components/common/BreadCrumbs/BreadCrumbs";
import { useNavigate } from "react-router-dom";
import { trackNavigation } from '../../../services/analytics';

const OverViewTabList: React.FC = () => {
  const navigate = useNavigate();
  const handleBreadcrumbPrevious = () => {
    console.log('📊 Analytics: Navigate back to tuition from overview');
    trackNavigation('tuition-overview', 'tuition', 'back');
    navigate("/tuition");
  };

  return (
    <div className="lg:!px-[160px] min-h[67vh]mx-auto px-4 py-6 sm:mx-[20px]!">
      <BreadCrumbs
        previousPage="Back to tuition reimbursement"
        currentPage=""
        onPreviousClick={handleBreadcrumbPrevious}
      />

      <h1 className="h1 !mt-[32px] !mb-[32px]">My Overview</h1>
      <Tabs tabs={OverviewTabsData} />
    </div>
  );
};

export default OverViewTabList;